namespace JupitersChoice {
    export class StopReelsCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('LocalStorageManager') _localStorageManager: Sapphire.LocalStorageManager;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('SpinModel') _spinModel: Sapphire.SpinModel;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const reels = this._componentManager.get('Reels');
            var spinInfo = this._stateModel.currentSubgame === 'FreeGame' ? response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1] : response;
            var isTurboMode = this._localStorageManager.get("settings.turboModeActive", false) || this._spinModel.isSkillStopRequested;
            var overallStopDelay = 0.3;
            var lockedReels = this._responseHelper.getLockedReels(spinInfo.lockedWithPreviousReel);
            var stopDelays = [];
            var reelsWhichContainWins: number[] = this._responseHelper.getReelIndexesWhichContainWins(spinInfo.winnings);

            this._responseHelper.getLastReelIndexWithWin(spinInfo.winnings);

            // Calculate stop delays
            var rollingDelay: number = 0;

            for (let i = 0; i < 6; i++) {
                let delayToAdd = 0;

                if (spinInfo.lockedWithPreviousReel[i] === false) {
                    delayToAdd = 0.38;

                    if (this._stateModel.currentSubgame === 'BaseGame') {
                        if (i > 1 && reelsWhichContainWins.indexOf(i) === -1 && Math.max(...reelsWhichContainWins) <= 3) {
                            delayToAdd -= 0.25;
                        }
                    }
                }

                rollingDelay += delayToAdd;
                stopDelays.push(rollingDelay);
            }

            if (lockedReels.length === 2 && lockedReels[0] === 0 && lockedReels[0] === 1) {
                stopDelays[2] -= 0.25;
            }

            if (isTurboMode) {
                stopDelays = [0.1, 0.1, 0.1, 0.1, 0.1, 0.1];
            }

            // SLOW DOWN REEL LOGIC
            if (this._responseHelper.hasMegaHit(spinInfo.winnings)) {
                reels.slowDown([0,1,2,3,4,5], 0.1, 16, Expo.easeOut);
                for (var reelIdx = 0; reelIdx < 6; ++reelIdx) {
                    stopDelays[reelIdx] += 4;
                }
            } else {
                if (this._stateModel.currentSubgame === 'FreeGame') {
                    if (lockedReels.length === 5) {
                        const lastLockedReel = lockedReels[lockedReels.length - 1];

                        if (lastLockedReel === 4) {
                            reels.slowDown(lockedReels, 0.1, 8);
                            lockedReels.forEach(idx => {
                                stopDelays[idx] += 2;
                            });
                        }

                        if (lastLockedReel === 5) {
                            const rand = Math.floor(Math.random() * 4) === 0;

                            if (rand) {
                                reels.slowDown(lockedReels, 0.1, 8);
                                lockedReels.forEach(idx => {
                                    stopDelays[idx] += 2;
                                });
                            }
                        }
                    } else if (lockedReels.length === 6) {
                        // Jupiter should laugh as he locks the reels. All reels should slow down as they come to a stop to build anticipation on the result

                        reels.slowDown(lockedReels, 0.1, 8);
                        lockedReels.forEach(idx => {
                            stopDelays[idx] += 2;
                        });
                    }
                }
            }

            TweenMax.delayedCall(overallStopDelay, () => {
                reels.stop(spinInfo.stops, stopDelays, () => {
                    this._eventManager.publish('onAllReelsStopped');
                });
            });
        }
    }
}